import { IFormattedAssetItem, useMutation } from '@northladder/services';

import { INBOUND_API } from '../../../inboundAPIClient';

/**
 * This is to track the scan port for creating evaluation mutation keys in
 * react query cache.
 */
const SCAN_PORT_FOR_CREATING_EVALUATION_MUTATION_KEY =
  'scan-port-for-creating-evaluation-mutation-key';

interface IUseScanPortForCreatingEvaluationParams {
  onSuccessCallback: (data: IFormattedAssetItem) => void;
}

/**
 * React Query mutation function for scanning a port for creating an evaluation.
 * This is the second step in creating an evaluation after scanning a package.
 */
export const useScanPortForCreatingEvaluation = ({
  onSuccessCallback,
}: IUseScanPortForCreatingEvaluationParams) => {
  const {
    data,
    error,
    isError,
    isPending,
    mutate: scanPortForCreatingEvaluation,
    reset: resetScanPortForCreatingEvaluation,
  } = useMutation({
    mutationKey: [SCAN_PORT_FOR_CREATING_EVALUATION_MUTATION_KEY],
    networkMode: 'always',
    mutationFn: INBOUND_API.scanPortForCreatingEvaluation,
    onSuccess: onSuccessCallback,
  });

  return {
    data,
    error,
    isError,
    isPending,
    resetScanPortForCreatingEvaluation,
    scanPortForCreatingEvaluation,
  };
};
